module.exports = __webpack_public_path__ + "img/img2.dc86f1af.png";